import { render } from "./pluginItem.vue?vue&type=template&id=df8157b8&scoped=true"
import script from "./pluginItem.vue?vue&type=script&lang=js"
export * from "./pluginItem.vue?vue&type=script&lang=js"

import "./pluginItem.vue?vue&type=style&index=0&id=df8157b8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df8157b8"]])

export default __exports__